import { render, staticRenderFns } from "./ListadoProf.vue?vue&type=template&id=058ba714&lang=html"
import script from "./ListadoProf.vue?vue&type=script&lang=js"
export * from "./ListadoProf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports